export const DATE_FORMAT = "ddd, MMM DD";
export const ROUND_TRIP = "Round-trip Flight";
export const ONE_WAY_TRIP = "One-way Flight";
export const EXPIRES_ON = "Expires on";
